<router-outlet></router-outlet>
<ngx-spinner name="loading-spinner" color="#000" bdColor="rgba(200,200,200,0.8)">
    <p class="loading">Just a moment...</p>
</ngx-spinner>